export const obterUrlEntidade = entidade => {
    if (!entidade.nome_abrev) return `https://${entidade.dominio}`;

    return entidade.dominio ? `https://${entidade.dominio}/${entidade.nome_abrev}` : `/${entidade.nome_abrev}`;
};
